module.exports = __webpack_public_path__ + "img/certificate8.514589ea.png";